import * as React from "react";
import { markdown, ReactSpecimen } from "catalog";
import { Modal, ModalText } from "./Modals";
import { Table } from "../theme/text";
export default () => markdown `

## Modals

Modals appear as an overlay after the user interacts with a \`ModalCard\`. They all use the same \`<Modal />\` wrapper component, with a child element based on the content to be displayed.

This component is never used alone, but in combination with a \`ModalCard\`.

### With paragraphs
${(<ReactSpecimen>
    <Modal mainHeading="Erhebungsmethode" iconName="Cross" onClose={e => console.log(e)}>
      {[
    "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
].map(t => <ModalText>{t}</ModalText>)}
    </Modal>
  </ReactSpecimen>)}

### With a table
${(<ReactSpecimen responsive>
    <Modal mainHeading="Aktualisierungsverlauf" iconName="Cross" onClose={e => console.log(e)}>
      <Table headers={["Bereich", "Plannung"]} rows={[
    ["Baustellenliste  A–Z", "Umsetzungstermin offen"],
    ["Archiv der Medienmitteilungen 2002–2007", "Keine Umsetzung"]
]}/>
    </Modal>
  </ReactSpecimen>)}

### With a very long content
${(<ReactSpecimen responsive>
    <Modal mainHeading="Aktualisierungsverlauf" iconName="Cross" onClose={e => console.log(e)}>
      <ModalText>
        Provisorische Daten; die Daten können ändern, wenn weitere Fälle
        nachgemeldet werden. Nachmeldungen nach statistischem Jahresabschluss
        werden dem Januar des Folgejahres zugeordnet. Die Stadt Zürich behält
        sich vor, einzelne Informationsangebote oder Funktionalitäten
        abzuändern, grundsätzlich neu zu gestalten oder ohne Vorankündigung vom
        Netz zu nehmen. Daher kann sie nicht verantwortlich gemacht werden für
        die Folgen, wenn gewisse Informationen nicht mehr oder nicht mehr in der
        bisherigen Form zur Verfügung stehen. Die Stadt Zürich kann nicht dafür
        einstehen, dass ihre elektronischen Informationsangebote sowie die
        angebotenen Funktionalitäten (wie z. B. eine Suchfunktion) jederzeit
        störungsfrei benutzt und die abgefragten Informationen reibungslos und
        fehlerfrei übertragen werden können. Die Stadt Zürich kann nicht
        gewährleisten, dass die von ihr auf dem Internet zur Verfügung
        gestellten Informationen jederzeit aktuell, detailgenau und vollständig
        sind und alle erdenklichen Sachverhalte berücksichtigen.
      </ModalText>
      <ModalText>
        Provisorische Daten; die Daten können ändern, wenn weitere Fälle
        nachgemeldet werden. Nachmeldungen nach statistischem Jahresabschluss
        werden dem Januar des Folgejahres zugeordnet. Die Stadt Zürich behält
        sich vor, einzelne Informationsangebote oder Funktionalitäten
        abzuändern, grundsätzlich neu zu gestalten oder ohne Vorankündigung vom
        Netz zu nehmen. Daher kann sie nicht verantwortlich gemacht werden für
        die Folgen, wenn gewisse Informationen nicht mehr oder nicht mehr in der
        bisherigen Form zur Verfügung stehen. Die Stadt Zürich kann nicht dafür
        einstehen, dass ihre elektronischen Informationsangebote sowie die
        angebotenen Funktionalitäten (wie z. B. eine Suchfunktion) jederzeit
        störungsfrei benutzt und die abgefragten Informationen reibungslos und
        fehlerfrei übertragen werden können. Die Stadt Zürich kann nicht
        gewährleisten, dass die von ihr auf dem Internet zur Verfügung
        gestellten Informationen jederzeit aktuell, detailgenau und vollständig
        sind und alle erdenklichen Sachverhalte berücksichtigen.
      </ModalText>
    </Modal>
  </ReactSpecimen>)}

`;



// WEBPACK FOOTER //
// ./src/components/Modals.docs.tsx